var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99997 17.9999H14V7.99993H1.99997V17.9999ZM7.99998 14.7499C8.48588 14.7499 8.89901 14.5797 9.23938 14.2393C9.57976 13.899 9.74995 13.4858 9.74995 12.9999C9.74995 12.514 9.57976 12.1009 9.23938 11.7605C8.89901 11.4201 8.48588 11.25 7.99998 11.25C7.51408 11.25 7.10094 11.4201 6.76058 11.7605C6.42019 12.1009 6.25 12.514 6.25 12.9999C6.25 13.4858 6.42019 13.899 6.76058 14.2393C7.10094 14.5797 7.51408 14.7499 7.99998 14.7499ZM0.5 19.4999V6.49995H9.5V4.49995C9.5 3.25125 9.93782 2.18908 10.8135 1.31345C11.6891 0.437817 12.7513 0 14 0C15.2487 0 16.3109 0.437817 17.1865 1.31345C18.0621 2.18908 18.5 3.25125 18.5 4.49995H17C17 3.66662 16.7083 2.95828 16.125 2.37495C15.5416 1.79162 14.8333 1.49995 14 1.49995C13.1666 1.49995 12.4583 1.79162 11.875 2.37495C11.2916 2.95828 11 3.66662 11 4.49995V6.49995H15.5V19.4999H0.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/LockOpen.eead47f7d0635a7f55450591e029fe46.svg";
export { ForwardRef as ReactComponent };